import React, {Component} from 'react'
import Swal from 'sweetalert2'
import commonMethod from '../lib/commonMethod'

class saveReset extends Component {
    constructor(props) {
        super(props);

        this.state = {
            group:null,
            groupName:"",
            filName:"",
            selectGroup:"",
            stepId:"",
            swalOpen:false,
        };
    }

    componentDidUpdate() {

        // if(this.props.accessToken && this.props.userId && !this.state.group) this.getGroup();
    }

    getGroup(callback = () => {}) {

        let data = {
            userToken :this.props.accessToken,
            bsId :this.props.userId
        }

        commonMethod.requestGet('api/Group/getGroupList',data,res=>{
            this.setState({group:res.data});
            callback(res)
        })

    }

    resetSearch() {
        this.setState({swalOpen:true});
        Swal.fire({
            title: 'Are you sure?',
            text: 'All the records will be deleted.',
            showCancelButton: true,
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
          }).then((result) => {
            if (result.value) {
                this.props.resetSearch()
            }
            this.setState({swalOpen:false});
          })
    }

    saveSearch() {

        this.getGroup(() => {
            let searchList = this.props.searchList;

            if(searchList.length!==0) {
                for(let i=0; i<searchList.length; i++) {
                    delete searchList[i].isNew;
                }
            }

            if(this.state.group.length===0) {
                // 그룹 없을 경우
                this.addGroup();
            } else {
                this.saveInGroup();
            }
        });
    }

    addGroup() {
        Swal.fire({
            title: 'Notice',
            text: '“Group” is required to save step search.',
            showCancelButton: true,
            reverseButtons:true,
            confirmButtonText: 'Create a group',
            cancelButtonText: 'Cancel',
            input:'text',
            inputValue: this.state.groupName,
            inputPlaceholder: 'Group name',
            inputValidator: (value) => {
                if (value) {
                    this.setState({groupName:value})
                } else {
                    return 'You need to write something!'

                }
            }
          }).then((result) => {
                if (result.value) {
                    let data = {
                        userToken : this.props.accessToken,
                        title : this.state.groupName,
                        content : " ",
                    };
                    commonMethod.requestPost('api/Group/createGroup',data,res=> {
                        // console.log(res);
                        this.getGroup(group=>this.saveInGroup());

                    })

                }
          })

    }

    saveInGroup() {

        let group = this.state.group;
        let groupOptions = "";

        console.log('group', group);

        for(let i=0; i<group.length; i++) {
            let selected = i===0 && "selected"
            groupOptions = groupOptions + "<option "+ selected +" value='"+ group[i].groupNo +"'>"+ group[i].name +"</option>"
        }

        this.setState({swalOpen:true});

        Swal.fire({
            showClass:{popup:"swal2-one"},
            title: 'Save a step search',
            confirmButtonText: 'save',
            input:'text',
            inputPlaceholder: 'File name',
            html:'<p class="description">Save step search as a group.</p><select class="swal2-select" id="group-select">'+
             groupOptions +'</select>',
            inputValidator: (value) => {
                let groupId = document.getElementById('group-select').value;
                if(value && groupId!=="") {
                    this.setState({fileName:value,selectGroup:groupId});
                } else {
                    return 'You need to write something!'
                }
            }
          }).then((result) => {
            if (result.value) {
                commonMethod.requestPost('api/Step/setInfo',
                    {
                        name:this.state.fileName,
                        groupId:this.state.selectGroup,
                        info:this.props.searchList,
                        userToken : this.props.accessToken,
                        uid:this.props.stepId && this.props.stepId !== "" ? this.props.stepId : commonMethod.makeId(13)
                    },res=> {
                        this.successSave(res.data);
                })
            }else{
                this.setState({swalOpen:false});
            }
      })

    }

    successSave(stepId) {

        let message = stepId ? "Successfully" : "Failure";
        Swal.fire({
            text: 'Saved ' + message,
            showClass:{popup:"swal2-one"},
            confirmButtonText:"OK",
          }).then((result) => {
            if (result.value) {
                this.setState({filName:"",selectGroup:""})
            }
            this.setState({swalOpen:false});
      })

    }

    render() {

        return (
            <React.Fragment>
                {this.state.swalOpen &&
                    <div className="swal2-mask"></div>
                }
                <div className="top-area">
                    <h2>Step Search</h2>
                    <div className="btn-list">
                        <button onClick={()=>this.resetSearch()}>reset</button>
                        <button onClick={()=>this.saveSearch()}>save</button>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


export default saveReset;
